// agriflow/activities/static/js/module/kanban/index.js
import { Modal } from 'bootstrap';
import Dropzone from 'dropzone';
import 'dropzone/dist/dropzone.css';


let activityMap = null;


/* 
* Handles the board modal.
*/
class BoardHandler {
    constructor() {
        this.modalElement = document.getElementById('boardModal');
        if (!this.modalElement) {
            return; 
        }
        this.modal = new Modal(this.modalElement);
        this.form = this.modalElement.querySelector('form');
        this.boardIdInput = this.modalElement.querySelector('#boardIdInput');
        this.boardNameInput = this.modalElement.querySelector('#boardNameInput');
        this.modalLabel = this.modalElement.querySelector('#boardModalLabel');
        this.modal = new Modal(this.modalElement);
        this.modalElement.addEventListener('click', (e) => {
            if (e.target.getAttribute('data-bs-dismiss') === 'modal') {
                this.modal.hide();
            }
        });
        
        if (this.form) {
            this.form.addEventListener('submit', (event) => this.handleFormSubmit(event));
        }
        this.createButton = document.querySelector('a[href="/kanban/create/"]');
        if (this.createButton) {
            this.createButton.addEventListener('click', () => this.openModalForCreate());
        }
    }
    openModalForCreate() {
        if (!this.modal) return;
        this.form.reset();
        this.boardIdInput.value = '';
        this.modalLabel.textContent = 'Neues Board erstellen';
        this.modal.show();
    }
    

    async openModalForUpdate(boardId) {
        if (!this.modal) return;
        try {
            const token = getCookie('drfToken') || getCookie('csrftoken');
            const response = await fetch(`/api/activities/activities/kanban/board/${boardId}/`, {
                headers: { 'Authorization': `Token ${token}` }
            });
            if (!response.ok) throw new Error('Board-Daten konnten nicht geladen werden.');
            const boardData = await response.json();
            
            this.form.reset();
            this.boardIdInput.value = boardId;
            this.boardNameInput.value = boardData.name || '';
            this.modalLabel.textContent = 'Board umbenennen';
            this.modal.show();
        } catch (error) {
            console.error(error);
        }
    }

    async handleFormSubmit(event) {
        event.preventDefault();
        const boardName = this.boardNameInput.value.trim();
        if (!boardName) return;
        
        await this.saveBoard(this.boardIdInput.value, boardName);
        this.modal.hide();
        location.reload();
    }

    async saveBoard(boardId, boardName) {
        const isUpdate = !!boardId;
        const url = isUpdate 
            ? `/api/activities/activities/update-board/${boardId}/`
            : '/api/activities/activities/create-board/';
        
        const authToken = getCookie('drfToken');

        return fetch(url, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json', 
                'Authorization': `Token ${authToken}`,
            },
            body: JSON.stringify({ name: boardName })
        }).then(response => {
            if (!response.ok) throw new Error('API-Fehler');
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {

    const createBoardLink = document.querySelector('a[href="/kanban/create/"]');
    if (createBoardLink) {

        createBoardLink.addEventListener('click', function(e) {
            e.preventDefault();
            new BoardHandler();
        });
    }


    document.body.addEventListener('click', function(event) {
        // --- DAS IST DER CODE, DEN DU FÜR DAS "BEARBEITEN" BRAUCHST ---
        const editButton = event.target.closest('#editBoardBtn');
        if (editButton) {
            const boardHandler = new BoardHandler();
            event.preventDefault();
            const boardId = document.getElementById('kanban-container').dataset.boardId;
            if (boardId) {
                boardHandler.openModalForUpdate(boardId);
            }
        }
    });

    const container = document.getElementById('kanban-container');
    if(!container) return;
    const boardId = container.getAttribute('data-board-id');

    Dropzone.autoDiscover = false;

    const createBtn = document.getElementById('createNewActivityBtn');
    if (createBtn) {
        createBtn.addEventListener('click', function() {
            openCreateActivityModal(boardId);
        });
    }

    fetch(`/api/activities/activities/kanban/board/${boardId}/`)
        .then(response => response.json())
        .then(data => {
            window.firstStatusId = data.statuses[0].id; 
            initializeJKanban(data);
        })
        .catch(error => {
            console.error('Fehler:', error);
        });

});


/**
 * Fügt einen einzelnen Anhang zur sichtbaren Liste im Modal hinzu.
 * @param {object} attachment - Das Anhang-Objekt mit id, file_name und file_url.
 */
function addAttachmentToList(attachment) {
    const attachmentsContainer = document.getElementById('activity-attachments-list');
    if (!attachmentsContainer) return;

    let list = attachmentsContainer.querySelector('ul.list-group');
    if (!list) {
        const emptyMessage = attachmentsContainer.querySelector('p');
        if (emptyMessage) emptyMessage.remove();
        
        list = document.createElement('ul');
        list.className = 'list-group mt-3';
        attachmentsContainer.appendChild(list);
    }

    const li = document.createElement('li');
    li.className = 'list-group-item d-flex justify-content-between align-items-center';
    li.id = `attachment-${attachment.id}`;
    li.innerHTML = `
        <a href="${attachment.file_url}" target="_blank">${attachment.file_name}</a>
        <button type="button" class="btn btn-sm btn-outline-danger delete-attachment-btn" data-attachment-id="${attachment.id}">Löschen</button>
    `;
    list.appendChild(li);
}

/**
 * Initialisiert die Dropzone für eine gegebene Aktivitäts-ID im Modal.
 * @param {number} activityId - Die ID der Aktivität.
 */
function initializeDropzone(activityId) {
    const dropzoneElement = document.getElementById('activity-dropzone-area');
    const modalBody = document.getElementById('activityModalBody');
    if (!dropzoneElement || !modalBody) return;

    if (dropzoneElement.dropzone) {
        dropzoneElement.dropzone.destroy();
    }

    const token = getCookie('drfToken'); 
    dropzoneElement.classList.remove('d-none');

    new Dropzone(dropzoneElement, {
        url: `/api/activities/attachments/upload/${activityId}/`,
        paramName: 'file',
        maxFilesize: 5,
        headers: { 'Authorization': `Token ${token}` },
        acceptedFiles: '.jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx',
        dictDefaultMessage: 'Dateien hier ablegen oder klicken zum Hochladen',
        success: function(file, response) {
            console.log('Upload erfolgreich:', response);
            file.previewElement.remove(); 
            displayAttachments(activityId); 
        },
        error: function(file, errorMessage) {
            console.error('Upload-Fehler:', errorMessage);
            const errorText = file.previewElement.querySelector("[data-dz-errormessage]");
            if (errorText) errorText.textContent = 'Upload fehlgeschlagen.';
        }
    });
}

/**
 * Ruft die Anhänge für eine Aktivität ab und zeigt sie im Modal an.
 * @param {number} activityId - Die ID der Aktivität.
 */
function displayAttachments(activityId) {
    const attachmentsContainer = document.getElementById('activity-attachments-list');
    if (!attachmentsContainer) return;

    const token = getCookie('drfToken');
    fetch(`/api/activities/attachments/list/${activityId}/`, {
        headers: { 'Authorization': `Token ${token}` }
    })
    .then(response => response.json())
    .then(data => {
        attachmentsContainer.innerHTML = ''; 
        if (data.attachments && data.attachments.length > 0) {
            data.attachments.forEach(attachment => {
                addAttachmentToList({
                    id: attachment.id,
                    file_name: attachment.name, 
                    file_url: attachment.url
                });
            });
        } else {
            attachmentsContainer.innerHTML = '<p class="text-muted mt-3">Noch keine Dokumente hochgeladen.</p>';
        }
    })
    .catch(error => console.error('Fehler beim Laden der Anhänge:', error));
}

/**
 * Löscht einen Anhang, nachdem die Bestätigung im Modal erfolgt ist.
 * @param {number} attachmentId - Die ID des Anhangs.
 */
function deleteAttachment(attachmentId) {
    const token = getCookie('drfToken');
    fetch(`/api/activities/attachments/delete/${attachmentId}/`, {
        method: 'DELETE',
        headers: { 'Authorization': `Token ${token}` }
    })
    .then(response => {
        if (response.ok) {
            const attachmentElement = document.getElementById(`attachment-${attachmentId}`);
            if (attachmentElement) {
                attachmentElement.remove();
            }
        } else {
            throw new Error('Fehler beim Löschen');
        }
    })
    .catch(error => {
        console.error('Lösch-Fehler:', error);
        alert('Das Dokument konnte nicht gelöscht werden.');
    });
}

document.addEventListener('click', function(event) {
    if (event.target.matches('.delete-attachment-btn')) {
        event.preventDefault();
        const attachmentId = event.target.getAttribute('data-attachment-id');
        if (!attachmentId) return;

        const confirmModalElement = document.getElementById('deleteConfirmModal');
        const confirmDeleteButton = document.getElementById('confirmDeleteBtn');
        if (!confirmModalElement || !confirmDeleteButton) return;

        confirmDeleteButton.dataset.attachmentId = attachmentId;
        const modal = new Modal(confirmModalElement);
        modal.show();
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const confirmDeleteButton = document.getElementById('confirmDeleteBtn');
    if (confirmDeleteButton) {
        confirmDeleteButton.addEventListener('click', function() {
            const attachmentId = this.dataset.attachmentId;
            if (attachmentId) {
                deleteAttachment(attachmentId);
                const modal = Modal.getInstance(document.getElementById('deleteConfirmModal'));
                modal.hide();
            }
        });
    }
});

/* 
* Initialisiert jKanban mit gelieferten Board-Daten und Click/Drag-Handlern. 
*/
function initializeJKanban(boardData) {
    
    if (typeof jKanban === 'undefined') return;

    const boards = boardData.statuses.map(status => ({
        id: `status-${status.id}`,
        title: `${status.name} (${status.activities.length})`,
        item: status.activities.map(activity => ({
            id: `activity-${activity.id}`,
            title: `<div class="kanban-card-custom">
                <strong>${activity.title}</strong><br>
                <small>${activity.assigned_name || ''}</small><br>
                <small>${activity.due_date ? new Date(activity.due_date).toLocaleDateString('de-DE') : ''}</small>
            </div>`
        }))
    }));

    injectKanbanDragFixes();

    const kanban = new jKanban({
        element: '#kanban-board',
        boards: boards,
        gutter: "0",
        widthBoard: "320px",
        dragBoards: false,
        dragItems: true,
        boardTitleInAnotherPosition: true,
        addItemButton: false,
        click: function(el) {
            const eid = el.getAttribute("data-eid");
            const activityId = eid.replace('activity-', '');
            console.log("Activity ID:", activityId);
            openActivityModal(activityId);
        },
        dragEl: function (el, source) {
            el.classList.add('is-dragging');
        },
        dragendEl: function (el) {
            el.classList.remove('is-dragging');
        },
        dropEl: function (el, target, source, sibling) {
            const activityId = el.getAttribute("data-eid").replace('activity-', '');
            const boardEl = target.closest('.kanban-board');
            if (!boardEl) return;
            const newStatusId = boardEl.getAttribute('data-id').replace('status-', '');
            console.log('Move activity', activityId, 'to status', newStatusId);
            updateActivityStatus(activityId, newStatusId);
        }
    });


}

/* 
* Aktualisiert serverseitig den Status einer Aktivität. 
* @param {number} activityId - Die ID der Aktivität.
* @param {number} statusId - Die ID des neuen Statuses.
*/
function updateActivityStatus(activityId, statusId) {

    const accessToken = getCookie('drfToken');
    if (!accessToken) return;
    fetch(`/api/activities/activities/${activityId}/move/`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${accessToken}`
        },
        body: JSON.stringify({ status_id: parseInt(statusId) })
    })
    .then(r => r.ok ? r.json() : Promise.reject(r))
    .then(data => console.log('Status updated:', data))
    .catch(err => { console.error('Fehler beim Update:', err); location.reload(); });
}



function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}


/*
* Injects the Kanban drag fixes.
*/
function injectKanbanDragFixes() {
    const STYLE_ID = 'kanban-drag-fixes';
    if (!document.getElementById(STYLE_ID)) {
        const css = `
        :root { --kanban-h: 70vh; }

        #kanban-board { 
            position: relative; 
            height: var(--kanban-h) !important; 
            display: flex !important;
        }
        #kanban-board .kanban-container {
            display: flex !important;
            gap: 20px !important;
            height: 100% !important;
            overflow-x: auto !important;
            overflow-y: hidden !important;
            scrollbar-width: none;
        }
        #kanban-board .kanban-container::-webkit-scrollbar { display: none; }

        #kanban-board .kanban-board {
            display: flex !important;
            flex-direction: column !important;
            height: 100% !important;
            min-height: 0 !important;
            padding: 10px !important;
            border-radius: 10px !important;
        }

        #kanban-board .kanban-title-board { 
            flex: 0 0 auto; 
            user-select: none; 
        }

        #kanban-board .kanban-drag { 
            flex: 1 1 auto; 
            min-height: 56px; 
            overflow-y: auto; 
            -webkit-overflow-scrolling: touch; 
            overscroll-behavior: contain; 
            padding-bottom: 8px;
        }

        #kanban-board .kanban-item {
            margin: 5px 0 !important;
            padding: 10px 12px;
            border-radius: 10px;
            background: #fff;
            box-shadow: 0 1px 2px rgba(0,0,0,.08);
            cursor: grab;
            user-select: none;
            -webkit-user-select: none;
            touch-action: none;
            will-change: transform, box-shadow;
            transform: translateZ(0);
            transition: box-shadow 80ms ease, transform 80ms ease;
        }
        #kanban-board .kanban-item:active { cursor: grabbing; }
        #kanban-board .kanban-item.is-dragging {
            box-shadow: 0 8px 24px rgba(0,0,0,.18);
            transform: translateZ(0) scale(1.02);
            opacity: .98;
            transition: none;
        }
        #kanban-board .kanban-item::before {
            content: "⋮⋮";
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            margin-right: 10px;
            margin-bottom: 10px;
            border-radius: 8px;      
            background: #fff;
            color: #666;
            font-weight: 700;
            line-height: 1;
            box-shadow: 0 0 0 1px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.08);
        }
        `;
        const style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = css;
        document.head.appendChild(style);
    }

    const apply = () => {
        const el = document.getElementById('kanban-board');
        if (!el) return;
        const top = el.getBoundingClientRect().top;
        const h = Math.max(200, Math.floor(window.innerHeight - top - 20));
        document.documentElement.style.setProperty('--kanban-h', `${h}px`);
    };

    apply();

    if (!window.__kanbanHeightBound) {
        window.__kanbanHeightBound = true;
        const onChange = () => requestAnimationFrame(apply);
        window.addEventListener('resize', onChange, { passive: true });
        window.addEventListener('orientationchange', onChange, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(onChange).observe(document.body);
        setTimeout(apply, 0);
        setTimeout(apply, 300);
    }
}


/*
* Öffnet das Fenster, um eine Aktivität zu bearbeiten.
*/
function openActivityModal(activityId) {
    const accessToken = getCookie('drfToken');
    if (!accessToken) return;

    async function loadStatusOptions(boardId, selectElement, currentStatusId = null) {
        const accessToken = getCookie('drfToken');
        try {
            const response = await fetch(`/api/activities/activities/board/${boardId}/statuses/`, {
                headers: { 'Authorization': `Token ${accessToken}` }
            });
            const statuses = await response.json();
            selectElement.innerHTML = '<option value=""></option>';
            statuses.forEach(status => {
                const option = document.createElement('option');
                option.value = status.id;
                option.textContent = status.name;
                if (currentStatusId && String(status.id) === String(currentStatusId)) {
                    option.selected = true;
                }
                selectElement.appendChild(option);
            });
        } catch (error) {
            console.error('Fehler beim Laden der Status:', error);
        }
    }

    Promise.all([
        fetch(`/api/global/form/activities`, {
            method: 'GET',
            headers: { 'Authorization': `Token ${accessToken}` }
        }).then(r => {
            if (!r.ok) throw new Error(`Formular-Endpoint fehlgeschlagen (${r.status})`);
            return r.json();
        }),
        fetch(`/api/activities/activities/activity/${activityId}`, {
            method: 'GET',
            headers: { 'Authorization': `Token ${accessToken}` }
        }).then(r => {
            if (!r.ok) throw new Error(`Aktivitäts-Endpoint fehlgeschlagen (${r.status})`);
            return r.json();
        })
    ])
    .then(([formSchema, activityData]) => {
        if (formSchema && activityData) {
            const schema = (formSchema && typeof formSchema === 'object') ? formSchema : null;
            const detail = (activityData && typeof activityData === 'object') ? activityData : null;
            if (!schema || !detail) return;

            populateActivityModal(detail, schema);
            const modalElement = document.getElementById('activityModal');
            if (!modalElement) { console.error('Modal-Element nicht gefunden'); return; }
            const modal = Modal.getOrCreateInstance(modalElement);
            modal.show();

            const boardId = document.getElementById('kanban-container')?.getAttribute('data-board-id');
            const statusSelect = document.getElementById('status_id');
            const currentStatusId = detail.status?.id;
            if (boardId && statusSelect) {
                loadStatusOptions(boardId, statusSelect, currentStatusId);
            }

            displayAttachments(activityId);
            initializeDropzone(activityId);
            document.querySelector('[data-bs-toggle="tab"][data-bs-target="#gps-tab"]')?.addEventListener('shown.bs.tab', () => {
                loadActivityGPSRoutes(activityId);
            }, { once: true });
        } else {
            console.error('Unerwartete Datenstruktur', { formSchema, activityData });
        }
    })
    .catch(error => {
        console.error('Fehler beim Laden:', error);
    });
}


/*
* Füllt das Fenster, um eine Aktivität zu bearbeiten.
*/
function populateActivityModal(activity, formSchema) {
    const modalTitle = document.getElementById('activityModalTitle');
    const modalBody  = document.getElementById('activityModalBody');
    if (!modalBody) return;

    const fields = Array.isArray(formSchema?.fields) ? formSchema.fields
                 : Array.isArray(formSchema?.form?.fields) ? formSchema.form.fields
                 : [];
    if (!fields.length) return;

    if (modalTitle) modalTitle.textContent = activity.title || 'Aktivität bearbeiten';


    let formHtml = `
        <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
                <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#form-tab">Formular</button>
            </li>
            <li class="nav-item">
                <button class="nav-link" data-bs-toggle="tab" data-bs-target="#gps-tab">GPS-Routen</button>
            </li>
            <li class="nav-item">
                <button class="nav-link" data-bs-toggle="tab" data-bs-target="#time-tab">Zeiterfassung</button>
            </li>
        </ul>
        
        <div class="tab-content mt-3">
            <div class="tab-pane fade show active" id="form-tab">
                <form id="activityForm">`;
    
                fields.forEach(field => { formHtml += createFormField(field, activity); });
    
            formHtml += `
            <hr>
                    <h6>Dokumente</h6>
                    <div id="activity-attachments-list"></div>
                    <div id="activity-dropzone-area" class="dropzone d-none mt-3"></div>
                </form>
            </div>
            <div class="tab-pane fade" id="gps-tab">
                <div id="activity-routes-list">GPS-Routen laden...</div>
            </div>
            <div class="tab-pane fade" id="time-tab">
                <div id="activity-time-list">Zeiterfassung laden...</div>
            </div>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-3">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Schließen</button>
            <button type="submit" form="activityForm" class="btn btn-primary">Speichern</button>
        </div>
    `;
    
    modalBody.innerHTML = formHtml;


    (function initSelect2Documents() {
        if (!(window.jQuery && jQuery.fn.select2)) { console.warn('Select2 nicht geladen'); return; }
    
        const $modal = jQuery('#activityModal');
        const $docSel = $modal.find('.js-select2-documents');
        if (!$docSel.length) return;
    
        if ($docSel.data('select2')) $docSel.select2('destroy');
        $docSel.select2({
            width: '100%',
            dropdownParent: $modal,
            placeholder: $docSel.data('placeholder') || '-- Bitte wählen --',
            allowClear: !$docSel.prop('required'),
            minimumResultsForSearch: 0,
            matcher: function(params, data) {
                if (!params.term) return data;
                const term = String(params.term).toLowerCase();
                const text = String(data.text || '').toLowerCase();
                const idt  = String(data.id || '').toLowerCase();
                return (text.includes(term) || idt.includes(term)) ? data : null;
            }
        });
    
        $docSel.on('select2:open', () => {
            const input = document.querySelector('.select2-container--open .select2-search__field');
            if (input) input.focus();
        });
    })();
    
    (function ensureSelect2ModalCss(){
        if (document.getElementById('select2-modal-fix')) return;
        const s = document.createElement('style');
        s.id = 'select2-modal-fix';
        s.textContent = `
          .select2-container{width:100%!important; z-index:2055;}
          .select2-dropdown{z-index:2060;}
        `;
        document.head.appendChild(s);
    })();

    const formEl = document.getElementById('activityForm');
    if (formEl) {
        formEl.addEventListener('submit', function(e) {
            e.preventDefault();
            if (typeof saveActivityChanges === 'function') saveActivityChanges(activity.id, formSchema);
        });
    }
}


/*
* Erstellt ein Formularfeld.
*/
function createFormField(field, activity) {
    const name = field.name;
    let value;
    switch (name) {
        case 'assigned_to_id': value = activity.assigned_to?.id ?? ''; break;
        case 'status_id':      value = activity.status?.id ?? ''; break;
        case 'category_id':    value = activity.category?.id ?? ''; break;
        case 'object_id':      value = activity.id ?? ''; break;
        case 'customer_id':    value = activity.customer?.id ?? ''; break;
        default:               value = (activity[name] ?? ''); break;
    }

    let html = `<div class="mb-3"><label for="${name}" class="form-label">${field.label || name}${field.required ? ' *' : ''}</label>`;

    if (field.type === 'textarea') {
        html += `<textarea class="form-control" id="${name}" name="${name}" ${field.required ? 'required' : ''}>${String(value)}</textarea>`;
    } else if (field.type === 'select') {
        const isDocuments = name === 'document_selection';
        const hasDataSource = field.data_source;
        const selectClass = (isDocuments || hasDataSource) ? 'form-select form-select-sm js-select2-documents' : 'form-select form-select-sm';
        const placeholder = field.label || name;
        html += `<select class="${selectClass}" id="${name}" name="${name}" ${field.required ? 'required' : ''}`
              + ((isDocuments || hasDataSource) ? ` data-placeholder="${placeholder}"` : ``)
              + `>`;
        if (!field.required) html += '<option value=""></option>';
        const opts = Array.isArray(field.options) ? field.options : [];
        let matched = false;
        opts.forEach(opt => {
            const ov = (opt.value ?? opt.id ?? '');
            const selected = String(ov) === String(value);
            if (selected) matched = true;
            html += `<option value="${ov}" ${selected ? 'selected' : ''}>${opt.label ?? String(ov)}</option>`;
        });
        if (!matched && value !== '' && opts.length) {
            html += `<option value="${String(value)}" selected>${String(value)}</option>`;
        }
        html += `</select>`;
    } else if (field.type === 'hidden') {
        html = `<input type="hidden" id="${name}" name="${name}" value="${String(value)}">`;
        return html;
    } else {
        let iv = String(value ?? '');
        if (field.type === 'date' && iv) {
            iv = /^\d{4}-\d{2}-\d{2}$/.test(iv) ? iv : new Date(iv).toISOString().split('T')[0];
        }
        const it = (field.type === 'date') ? 'date' : 'text';
        html += `<input type="${it}" class="form-control" id="${name}" name="${name}" value="${iv}" ${field.required ? 'required' : ''}>`;
    }

    html += `</div>`;
    return html;
}


/*
* Speichert die Änderungen an einer Aktivität.
*/
function saveActivityChanges(activityId, formSchema) {
    const accessToken = getCookie('drfToken');
    if (!accessToken) return;
    
    const form = document.getElementById('activityForm');
    const formData = new FormData(form);
    const data = {};
    
    formSchema.fields.forEach(field => {
        const value = formData.get(field.name);
        if (value !== null && value !== '') {
            data[field.name] = value;
        }
    });
    console.log('Gesendete Daten:', JSON.stringify(data, null, 2));
    fetch(`/api/activities/activities/activity/${activityId}/update/`, {
        method: 'POST',
        headers: {
            'Authorization': `Token ${accessToken}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(result => {
        document.getElementById('activityModal').style.display = 'none';
        location.reload();
    })
    .catch(error => {
        console.error('Speichern-Fehler:', error);
    });
}


/*
* Öffnet das Fenster, um eine neue Aktivität zu erstellen.
*/
function openCreateActivityModal(boardId) {
    const accessToken = getCookie('drfToken');
    if (!accessToken) return;

    fetch(`/api/global/form/activities`, {
        method: 'GET',
        headers: { 'Authorization': `Token ${accessToken}` }
    })
    .then(r => {
        if (!r.ok) throw new Error(`Formular-Endpoint fehlgeschlagen (${r.status})`);
        return r.json();
    })
    .then(formSchema => {
        populateCreateModal(formSchema, boardId);
        const modalElement = document.getElementById('activityModal');
        if (!modalElement) return; 
        const modal = Modal.getOrCreateInstance(modalElement);
        modal.show();
    })
    .catch(error => {
        console.error('Fehler beim Laden des Formulars:', error);
    });
}


/*
* Füllt das Fenster, um eine neue Aktivität zu erstellen.
*/
function populateCreateModal(formSchema, boardId) {
    const modalTitle = document.getElementById('activityModalTitle');
    const modalBody = document.getElementById('activityModalBody');
    if (!modalBody) return;

    const fields = Array.isArray(formSchema?.fields) ? formSchema.fields
                 : Array.isArray(formSchema?.form?.fields) ? formSchema.form.fields
                 : [];
    if (!fields.length) return;

    if (modalTitle) modalTitle.textContent = 'Neue Aktivität erstellen';

    let firstStatusId = window.firstStatusId || null;

    const emptyActivity = {
        id: null,
        title: '',
        description: '',
        assigned_to: null,
        status: firstStatusId ? { id: firstStatusId } : null,
        category: null,
        due_date: '',
        priority: '',
        board_id: boardId
    };

    let formHtml = '<form id="createActivityForm">';

    formHtml += `<input type="hidden" name="object_id" value="${boardId}">`;
    if (firstStatusId) {
        formHtml += `<input type="hidden" name="status_id" value="${firstStatusId}">`;
    }

    fields.forEach(field => { 
        formHtml += createFormField(field, emptyActivity); 
    });

    formHtml += `
        <hr>
        <h5>Dokumente</h5>
        <div id="activity-attachments-list">
             <p class="text-muted mt-3">Dokumente können nach dem Erstellen der Aktivität hinzugefügt werden.</p>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-3">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Abbrechen</button>
            <button type="submit" class="btn btn-primary">Erstellen</button>
        </div>
    </form>`;
    modalBody.innerHTML = formHtml;

    (function initSelect2Documents() {
        if (!(window.jQuery && jQuery.fn.select2)) { console.warn('Select2 nicht geladen'); return; }
    
        const $modal = jQuery('#activityModal');
        const $docSel = $modal.find('.js-select2-documents');
        if (!$docSel.length) return;
    
        if ($docSel.data('select2')) $docSel.select2('destroy');
        $docSel.select2({
            width: '100%',
            dropdownParent: $modal,
            placeholder: $docSel.data('placeholder') || '-- Bitte wählen --',
            allowClear: !$docSel.prop('required'),
            minimumResultsForSearch: 0,
            matcher: function(params, data) {
                if (!params.term) return data;
                const term = String(params.term).toLowerCase();
                const text = String(data.text || '').toLowerCase();
                const idt  = String(data.id || '').toLowerCase();
                return (text.includes(term) || idt.includes(term)) ? data : null;
            }
        });
    
        $docSel.on('select2:open', () => {
            const input = document.querySelector('.select2-container--open .select2-search__field');
            if (input) input.focus();
        });
    })();
    
    (function ensureSelect2ModalCss(){
        if (document.getElementById('select2-modal-fix')) return;
        const s = document.createElement('style');
        s.id = 'select2-modal-fix';
        s.textContent = `
          .select2-container{width:100%!important; z-index:2055;}
          .select2-dropdown{z-index:2060;}
        `;
        document.head.appendChild(s);
    })();

    const formEl = document.getElementById('createActivityForm');
    if (formEl) {
        formEl.addEventListener('submit', function(e) {
            e.preventDefault();
            createNewActivity(formSchema, boardId);
        });
    }
}



/*
* Erstellt eine neue Aktivität.
*/
function createNewActivity(formSchema, boardId) {
    const accessToken = getCookie('drfToken');
    if (!accessToken) return;
    const form = document.getElementById('createActivityForm');
    const formData = new FormData(form);
    const data = {};
    
    formSchema.fields.forEach(field => {
        const value = formData.get(field.name);
        if (value !== null && value !== '') {
            data[field.name] = value;
        }
    });
    
    data.board_id = boardId;
    if (!data.status_id && window.currentBoardData && window.currentBoardData.statuses) {
        data.status_id = window.currentBoardData.statuses[0].id;
    }
    
    fetch(`/api/activities/activities/create-activity/`, {
        method: 'POST',
        headers: {
            'Authorization': `Token ${accessToken}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(result => {
        console.log('Neue Aktivität erstellt:', result);
        const newActivityId = result.id;

        if (newActivityId) {

            const modalTitle = document.getElementById('activityModalTitle');
            if (modalTitle) modalTitle.textContent = 'Dokumente hinzufügen';
            
            form.querySelector('button[type="submit"]').style.display = 'none';
            form.dataset.activityId = newActivityId;
            
            document.getElementById('activity-attachments-list').innerHTML = '';
            initializeDropzone(newActivityId);
            displayAttachments(newActivityId);
            
            const closeBtn = form.querySelector('button[data-bs-dismiss="modal"]');
            closeBtn.textContent = "Fertig";
            closeBtn.addEventListener('click', () => location.reload(), { once: true });
            
        } else {
             location.reload(); 
        }
    })
    .catch(error => {
        console.error('Fehler beim Erstellen der Aktivität:', error);
    });
}


async function loadActivityGPSRoutes(activityId) {
    const accessToken = getCookie('drfToken');
    if (!accessToken) return;
    try {
        const response = await fetch(`/api/gpstracking/routes_api/get-route-by-activity/?activity_id=${activityId}`, {
            headers: { 'Authorization': `Token ${accessToken}` }
        });
        if (!response.ok) throw new Error('Routen konnten nicht geladen werden');
        const data = await response.json();
        const container = document.getElementById('activity-routes-list');
        if (!container) return;
        const hasRoutes = data.routes && data.routes.length > 0;
        const existingOrderRoute = data.routes.find(r => r.order_id);
        const existingOrderId = existingOrderRoute ? existingOrderRoute.order_id : null;

        let orderLink = '';
        if (data.routes && data.routes.length > 0 && data.routes[0] && data.routes[0].order_id) {
            orderLink = `<a href="/orders/update/${data.routes[0].order_id}/" target="_blank" class="btn btn-primary btn-sm"><i class="fas fa-external-link-alt"></i> Auftrag öffnen</a>`;
        }

        container.innerHTML = `<div id="route-map" style="height:300px;width:100%;margin-bottom:15px;position:relative;"></div>
            <div class="d-flex gap-2 mb-3">
                <button id="start-gps-tracking" class="btn btn-success btn-sm">
                    <i class="fas fa-plus"></i> Neue Route erstellen
                </button>
                <button id="createOrderBtn" class="btn btn-secondary btn-sm">
                    <i class="fas fa-sync"></i> Auftrag erstellen
                </button>
                ${orderLink}
                <span id="createOrderStatus" class="ms-2 text-muted" aria-live="polite"></span>
            </div>
            ${hasRoutes ? `
            <div style="max-height:300px;overflow-y:auto;">
                ${data.routes.map(route => {
                    const startTime = new Date(route.start_time).toLocaleString('de-DE', {
                        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
                    });
                    const endTime = route.end_time ? new Date(route.end_time).toLocaleString('de-DE', {
                        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
                    }) : '-';
                    const status = route.is_closed ? 'closed' : (route.is_active ? 'active' : 'ready');
                    const badgeClass = status === 'active' ? 'bg-success' : (status === 'closed' ? 'bg-secondary' : 'bg-warning');
                    const buttonDisabled = status === 'closed' ? 'disabled' : '';
                    const buttonLabel = status === 'closed' ? 'Geschlossen' : 'Anzeigen';
                    const buttonStyle = status === 'ready' ? 'btn-warning' : 'btn-primary';
                    
                    return `
                        <div class="border rounded p-3 mb-2">
                            <div class="row align-items-center">
                                <div class="col-4">
                                    <h6 class="mb-1">${route.name}</h6>
                                    <small class="text-muted">Start: ${startTime}</small><br>
                                    <small class="text-muted">Ende: ${endTime}</small><br>
                                    ${route.order_id ? ` <span class="badge bg-success">Im Auftrag</span>` : ''}
                                    <span class="badge ${badgeClass}">
                                        ${status === 'active' ? 'Aktiv' : (status === 'closed' ? 'Geschlossen' : 'Bereit')}
                                    </span>                 
                                </div>
                                <div class="col-8 text-end">
                                    <button class="btn btn-sm mt-1 ${buttonStyle} view-route-btn" data-route-id="${route.id}" ${buttonDisabled}>
                                        ${buttonLabel}
                                    </button>
                                    ${!route.order_id && existingOrderId ? `<button class="btn btn-sm btn-primary mt-1 add-to-order-btn" data-route-id="${route.id}" data-order-id="${existingOrderId}">Zu Auftrag hinzufügen</button>` : ''}
                                    ${!route.field_polygon_data ? `
                                        <button class="btn btn-sm btn-success mt-1 gps-start-btn" data-route-id="${route.id}">Start</button>
                                        <button class="btn btn-sm btn-danger mt-1 gps-stop-btn" data-route-id="${route.id}" style="display:none">Stop</button>
                                        <button class="btn btn-sm btn-secondary mt-1 gps-close-btn" data-route-id="${route.id}">Route schließen</button>
                                    ` : ''}
                                </div>
                            </div>
                        </div>
                    `;
                }).join('')}
            </div>
            ` : '<p class="text-muted">Keine Routen vorhanden. Klicken Sie auf ein Feld, um eine Route zu erstellen.</p>'}
        `;
        activityMap = L.map('route-map', { center: [47.5, 14.0], zoom: 13, minZoom: 10, maxZoom: 20 });
        const tiles = L.tileLayer(
            'https://api.maptiler.com/maps/openstreetmap/{z}/{x}/{y}.png?key=msAWRru7q043rqx3RU5P',
            { attribution: '© MapTiler © OpenStreetMap', minZoom: 10, maxZoom: 20 }
        ).addTo(activityMap);
        tiles.on('tileerror', () => {
            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '© OpenStreetMap contributors', minZoom: 10, maxZoom: 19
            }).addTo(activityMap);
        });

        const modalEl = container.closest('.modal');
        if (modalEl) {
            modalEl.addEventListener('shown.bs.modal', () => {
                activityMap.invalidateSize(true);
            }, { once: true });
        }
        setTimeout(() => activityMap.invalidateSize(true), 0);

        let geolocationStatus = 'pending';          
        let userMarker = null;
        let accuracyCircle = null;
        let hasCenteredOnFix = false;
        let highlightedLayer = null;

        function updateUserLocation(lat, lon, acc) {
            if (userMarker) userMarker.setLatLng([lat, lon]);
            else userMarker = L.marker([lat, lon]).addTo(activityMap).bindPopup('Aktueller Standort');

            if (accuracyCircle) accuracyCircle.setLatLng([lat, lon]).setRadius(acc || 20);
            else accuracyCircle = L.circle([lat, lon], { radius: acc || 20, weight: 1, fillOpacity: 0.08 }).addTo(activityMap);

            if (!hasCenteredOnFix) {
                hasCenteredOnFix = true;
                activityMap.setView([lat, lon], 16);
                userMarker.openPopup();
            }
        }

        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                pos => {
                    geolocationStatus = 'ok';
                    updateUserLocation(pos.coords.latitude, pos.coords.longitude, pos.coords.accuracy);
                },
                err => {
                    geolocationStatus = (err.code === err.PERMISSION_DENIED) ? 'denied' : 'error';
                },
                { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
            );

            navigator.geolocation.watchPosition(
                pos => {
                    geolocationStatus = 'ok';
                    updateUserLocation(pos.coords.latitude, pos.coords.longitude, pos.coords.accuracy);
                },
                err => {
                    geolocationStatus = (err.code === err.PERMISSION_DENIED) ? 'denied' : 'error';
                },
                { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
            );
        } else {
            geolocationStatus = 'error';
        }

        let schlaegeLayer = null;
        let isFirstLoad = true;
        let moveDebounce = null;
        const maxFeaturesToRender = 300;

        function safeFitBounds(bounds) {
            if (!bounds || !bounds.isValid()) return;
            const z = activityMap.getBoundsZoom(bounds);
            const minZ = 12;
            if (z < minZ) {
                activityMap.setView(bounds.getCenter(), minZ);
            } else {
                activityMap.fitBounds(bounds, { padding: [20, 20] });
            }
        }

        function loadSchlaege() {
            const bounds = activityMap.getBounds();
            const bbox = encodeURIComponent(bounds.toBBoxString());
            fetch(`/gpstracking/api/schlaege/?bbox=${bbox}`, { headers: { 'Accept': 'application/json' }})
                .then(r => r.json())
                .then(geojson => {

                    let dataToUse = geojson;
                    if (Array.isArray(geojson.features) && geojson.features.length > maxFeaturesToRender) {
                        dataToUse = { type: 'FeatureCollection', features: geojson.features.slice(0, maxFeaturesToRender) };
                    }

                    if (schlaegeLayer) activityMap.removeLayer(schlaegeLayer);
                    schlaegeLayer = L.geoJSON(dataToUse, {
                        style: () => ({ weight: 1 }),
                        onEachFeature: (feat, layer) => {
                            const area = feat.properties?.SL_FLAECHE_BRUTTO_HA != null
                                ? Number(feat.properties.SL_FLAECHE_BRUTTO_HA).toFixed(2)
                                : '?';
                            const usage = feat.properties?.SNAR_BEZEICHNUNG || 'unbekannt';
                            const popupContent = `
                                <div>
                                    <strong>Fläche:</strong> ${area} ha<br/>
                                    <strong>Nutzung:</strong> ${usage}<br/>
                                    <button class="btn btn-sm btn-success mt-2 create-route-btn">
                                        <i class="fas fa-plus"></i> Route erstellen
                                    </button>
                                </div>
                            `;
                            layer.bindPopup(popupContent);
                            layer.on('popupopen', () => {
                                const btn = document.querySelector('.create-route-btn');
                                if (btn) {
                                    btn.onclick = () => {
                                        createRouteFromField(activityId, feat, area, usage);
                                        activityMap.closePopup();
                                    };
                                }
                            });
                        }
                    }).addTo(activityMap);

                    if (isFirstLoad && schlaegeLayer.getBounds().isValid() && !hasCenteredOnFix) {
                        safeFitBounds(schlaegeLayer.getBounds());
                    }
                    isFirstLoad = false;
                })
                .catch(err => console.error('Schläge-Load-Fehler:', err));
        }

        loadSchlaege();
        activityMap.on('moveend', () => {
            if (moveDebounce) clearTimeout(moveDebounce);
            moveDebounce = setTimeout(loadSchlaege, 300);
        });

        container.addEventListener('click', (event) => {
            if (event.target.classList.contains('view-route-btn')) {
                const routeId = event.target.getAttribute('data-route-id');
                if (routeId) {
                    fetch(`/api/gpstracking/routes/${routeId}/`, {
                        headers: { 'Authorization': `Token ${accessToken}` }
                    })
                    .then(r => r.json())
                    .then(route => {
                        console.log(route)
                        if (route.field_polygon_data?.geometry) {
                            if (highlightedLayer) activityMap.removeLayer(highlightedLayer);
                            highlightedLayer = L.geoJSON(route.field_polygon_data.geometry, {
                                style: { weight: 3, color: '#ff0000', fillOpacity: 0.5 }
                            }).addTo(activityMap);
                            activityMap.fitBounds(highlightedLayer.getBounds());
                            highlightedLayer.bindPopup(`
                                <strong>${route.name}</strong><br/>
                                Fläche: ${route.field_polygon_data.area_ha} ha<br/>
                                Nutzung: ${route.field_polygon_data.usage}
                            `).openPopup();
                        }  else if (route.gps_data && route.gps_data.length > 0) {
                            const latlngs = route.gps_data.map(p => [parseFloat(p.latitude), parseFloat(p.longitude)]);
                            highlightedLayer = L.polyline(latlngs, {color: 'purple', weight: 3}).addTo(activityMap);
                            activityMap.fitBounds(highlightedLayer.getBounds());
                        }
                    })
                    .catch(err => console.error('Fehler:', err));
                }
            }
        });



        const trackBtn = document.getElementById('start-gps-tracking');
        if (trackBtn && 'geolocation' in navigator) {
            let activityTitle = '';
            try {
                const actResponse = await fetch(`/api/activities/activities/activity/${activityId}`, {
                    headers: { 'Authorization': `Token ${accessToken}` }
                });
                if (actResponse.ok) {
                    const actData = await actResponse.json();
                    activityTitle = actData.title || 'Route';
                }
            } catch (e) {
                console.log('Aktivität konnte nicht geladen werden');
            }

            trackBtn.onclick = async () => {
                try {
                    const response = await fetch('/api/gpstracking/routes_api/create-route-with-document/', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Token ${accessToken}`
                        },
                        body: JSON.stringify({
                            activity_id: activityId,
                            route_name: `Route ${activityTitle} ${new Date().toLocaleTimeString('de-DE')}`
                        })
                    });
                    if (!response.ok) return;
                    const data = await response.json();
                    console.log('Route angelegt:', data.route_id);
                    loadActivityGPSRoutes(activityId);
                } catch (error) {
                    console.error('Fehler:', error);
                }
            };
        }


        if (!window.createOrderListenerAdded) {
            window.createOrderListenerAdded = true;
            container.addEventListener('click', async function(event) {
                if (event.target.closest('#createOrderBtn')) {
                    const currentActivityId = container.dataset.activityId || activityId;
                    if (!currentActivityId) return;
                    const accessToken = getCookie('drfToken');
                    try {
                        const response = await fetch('/api/activities/activities/create-order-from-activities/', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Token ${accessToken}`
                            },
                            body: JSON.stringify({ activity_id: currentActivityId })
                        });
                        
                        const data = await response.json();
                        if (data.success) {
                            const createOrderStatus = document.getElementById('createOrderStatus');
                            if (createOrderStatus) {
                                createOrderStatus.textContent = data.message || 'Auftrag erstellt';
                                setTimeout(() => {
                                    const createOrderStatus = document.getElementById('createOrderStatus');
                                    if (createOrderStatus) createOrderStatus.textContent = '';
                                    loadActivityGPSRoutes(activityId);
                                }, 3000); 
                            }
                        } else {
                            console.log('Fehler beim Erstellen:', data);
                            const createOrderStatus = document.getElementById('createOrderStatus');
                            if (createOrderStatus) {
                                createOrderStatus.textContent = 'Fehler: Kein Kunde ausgewählt';
                                createOrderStatus.style.color = 'red';
                                setTimeout(() => {
                                    createOrderStatus.textContent = '';
                                    createOrderStatus.style.color = '';
                                }, 3000);
                            }
                        }
                    } catch (error) {
                        console.error('Fehler:', error);
                    }
                }
            });
        }

        let activeSocket = null;
        let activeWatchId = null;

        if (!window.handleGPSClick) {
                window.handleGPSClick = function(e) {
                if (e.target.classList.contains('add-to-order-btn')) {
                    const routeId = e.target.getAttribute('data-route-id');
                    const orderId = e.target.getAttribute('data-order-id');
                    e.target.disabled = true;
                    fetch(`/api/gpstracking/routes/${routeId}/add-to-order/`, {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Token ${accessToken}`
                        },
                        body: JSON.stringify({ order_id: orderId })
                    })
                    .then(response => response.ok ? response.json() : Promise.reject(response))
                    .then(data => { console.log('Hinzugefuegt:', data); loadActivityGPSRoutes(activityId); })
                    .catch(error => { console.error('Fehler:', error); e.target.disabled = false; });
                }
                if (e.target.classList.contains('gps-start-btn')) {
                    const routeId = e.target.getAttribute('data-route-id');
                    e.target.style.display = 'none';
                    e.target.nextElementSibling.style.display = 'inline-block';    
                    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
                    const websocketURL = isLocal 
                        ? `ws://${window.location.host}/ws/track/?route_id=${routeId}`
                        : `wss://agriflow.pixel-west.com/ws/track/?route_id=${routeId}`;
                    console.log('[GPS] WebSocket URL:', websocketURL);
                    activeSocket = new WebSocket(websocketURL);
                    activeSocket.onopen = () => {
                        activeWatchId = navigator.geolocation.watchPosition(
                            (position) => {
                                if (activeSocket && activeSocket.readyState === WebSocket.OPEN) {
                                    activeSocket.send(JSON.stringify({
                                        route_id: routeId,
                                        latitude: position.coords.latitude,
                                        longitude: position.coords.longitude
                                    }));
                                    console.log('GPS gesendet:', position.coords.latitude, position.coords.longitude);
                                }
                            },
                            (error) => console.error('GPS-Fehler:', error),
                            { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
                        );
                    };
                }
                if (e.target.classList.contains('gps-stop-btn')) {
                    const routeId = e.target.getAttribute('data-route-id');
                    e.target.style.display = 'none';
                    e.target.previousElementSibling.style.display = 'inline-block';
                    if (activeWatchId) {
                        navigator.geolocation.clearWatch(activeWatchId);
                        activeWatchId = null;
                    }
                    if (activeSocket) {
                        activeSocket.close();
                        activeSocket = null;
                    }
                }
                if (e.target.classList.contains('gps-close-btn')) {
                    const routeId = e.target.getAttribute('data-route-id');
                    e.target.disabled = true;
                    fetch(`/api/gpstracking/routes/${routeId}/close-route/`, {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Token ${accessToken}`
                        }
                    })
                    .then(response => {
                        if (!response.ok) throw response;
                        return response.json();
                    })
                    .then(data => {
                        console.log('Route geschlossen:', data);
                        if (data.is_closed) {
                            console.log('Route wurde erfolgreich geschlossen');
                        }
                        // loadActivityGPSRoutes(activityId);
                    })
                    .catch(error => {
                        console.error('Fehler beim Schließen:', error);
                        e.target.disabled = false;
                    });
                }
            };
        }

        container.removeEventListener('click', window.handleGPSClick);
        container.addEventListener('click', window.handleGPSClick);

    } catch (error) {
        console.error('Fehler:', error);
    }
}




async function createRouteFromField(activityId, fieldFeature, area, usage) {
    const accessToken = getCookie('drfToken');
    if (!accessToken) return;
    const routeName = `Route ${fieldFeature.properties?.SNAR_BEZEICHNUNG || 'Feld'} (${area} ha)`;
    try {
        const response = await fetch('/api/gpstracking/routes_api/create-route-with-document/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${accessToken}`
            },
            body: JSON.stringify({
                activity_id: activityId,
                route_name: routeName,
                field_data: {
                    geometry: fieldFeature.geometry,
                    properties: fieldFeature.properties,
                    area_ha: area,
                    usage: usage
                }
            })
        });
        if (!response.ok) {
            const errorData = await response.json();
            console.error('Backend sagt:', errorData);
            throw new Error('Route konnte nicht erstellt werden');
        }
        const data = await response.json();
        loadActivityGPSRoutes(activityId);
    } catch (error) {
        console.error('Backend error:', errorData);
        alert('Fehler beim Erstellen der Route');
    }
}


